import React from 'react';
import '../styles/AblIntro.css';

function MatiIntro() {
  return (
    <section className="abl-division">
      <div className="abl-header">
        <div className="title-section">
          <span className="division-label">DIVISION</span>
          <h1 className="division-title">Monowara Active Technical Institute</h1>
        </div>
        <div className="division-description">
          <p>
            Akij Insaf Group is a trusted name in the business community of Bangladesh. With a legacy of excellence, innovation, and integrity, we have built a diverse portfolio that spans multiple industries — from manufacturing and construction to healthcare and education.

Our mission is to create sustainable impact through responsible business practices, while our vision is to lead the nation toward a better tomorrow.
          </p>
        </div>
      </div>
      
    </section>
  );
}

export default MatiIntro;
